const route = [
    {//语文检查作业详情-课文预习
        path: '/chinese/inspect/beforedetial/:classid/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/beforedetial.vue'], resolve);
        }
    },

    {//语文检查作业详情   
        path: '/chinese/inspect/taskdetial/:classid/:taskid/:taskType/:testType',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/taskdetial.vue'], resolve);
        }
    },
    {//单个试题错误详情
        path: '/chinese/inspect/errorrate/:classid/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/errorRate.vue'], resolve);
        }
    },
    {//单个试题错误详情-课外阅读
        path: '/chinese/inspect/outread/errorrate/:classid/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/errorRateOR.vue'], resolve);
        }
    },
    {//语文检查作业-课外阅读列表
        path: '/chinese/inspect/outread/:classid/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/outReadlist.vue'], resolve);
        },
    },
    {//检查作业详情-课外阅读
        path: '/chinese/inspect/outread/detial/:classid/:taskid/:reid/:taskType',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/taskdetial.vue'], resolve);
        },
    },
    {//检查作业课外阅读-预览
        path: '/chinese/inspect/outread/preview',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/outreadPreview.vue'], resolve);
        },
    },
    {//语文检查作业详情带图片（备用）
        path: '/chinese/inspect/listendetial',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/listendetial.vue'], resolve);
        }
    },
    {//语文检查作业学生情况-图片
        path: '/chinese/inspect/preview/pic/:classid/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/picPreview.vue'], resolve);
        }
    },
    {//作业预览-作业 2同步习题 3单元复习 4高频错题
        path: '/chinese/inspect/preview/task/:taskid/:testType',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/taskPreview.vue'], resolve);
        }
    },
    {//活动作业预览-作业 2同步习题 3单元复习 4高频错题
        path: '/chinese/inspect/preview/task/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/taskPreview.vue'], resolve);
        }
    },
    {//作业预览-作业 5生词听写
        path: '/chinese/inspect/preview/words/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/wordsPreview.vue'], resolve);
        }
    },
    {//作业预览-作业1:课文预习
        path: '/chinese/inspect/preview/word/:taskid',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/wordPreview.vue'], resolve);
        }
    },
    {//作业详情-个人作业
        path: '/chinese/inspect/mytask/:taskid/:user_id/:username',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/mytask.vue'], resolve);
        }
    },
    {//作业详情-个人作业-课外阅读
        path: '/chinese/inspect/mytask/outread/:taskid/:user_id/:username',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/mytaskOR.vue'], resolve);
        }
    },
    //2022-07-29新增查看作业
    {
        path: '/chinese/inspect/course',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/course.vue'], resolve);
        }
    },
    {
        path: '/chinese/inspect/stuDetail',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/stuDetail.vue'], resolve);
        }
    }, {
        path: '/chinese/inspect/taskDetail',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/taskDetail2.vue'], resolve);
        }
    }, {
        path: '/chinese/inspect/knowledgDetail',
        component: function (resolve) {
            require(['VIEWS/chinese/inspect/knowledgDetail.vue'], resolve);
        }
    }
];
export default route
